import AddIcon from "@mui/icons-material/Add";
import { useSnackbar } from "notistack";
import { useEffect, useState } from "react";
import AuthService from "../../AuthService";
import BarraTitulo from "../Generico/BarraTitulo";

import { Box, Button, useMediaQuery, useTheme } from "@mui/material";
import Template from "../Generico/Template";
import DialogFormaDePagamento from "./components/DialogFormaDePagamento";
import HelperTokenAsaas from "./components/HelperTokenAsaas";
import HelperTokenPicpay from "./components/HelperTokenPicpay";
import TableFormaDePagamento from "./components/TableFormaDePagamento";
import {
  TIPO_FORMAS_PAGAMENTO,
  TIPO_FORMAS_PAGAMENTO_ONLINE,
} from "./payments.config";

const FormaPagamento = () => {
  const { enqueueSnackbar } = useSnackbar();

  const [formaDePagamentos, setFormaDePagamentos] = useState([]);
  const [fpInput, setFpInput] = useState({
    descricao: "",
    tipo: "",
    tipoOnline: "",
    ativo: true,
    ordem: 0,
    tipoChave: "",
    chavePix: "",
    nomeBeneficiario: "",
    cidadeBeneficiario: "",
    tipoPagamento: "local",
    asaasToken: "",
  });
  const [open, setOpen] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);
  const [picPayHelpDialog, setPicPayHelpDialog] = useState(false);
  const [asaasHelpDialog, setAsaasHelpDialog] = useState(false);
  const [actives, setActives] = useState(true);
  const theme = useTheme();
  const isTablet = useMediaQuery(theme.breakpoints.down("md"));

  useEffect(() => {
    handleListFormaPagamento();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [actives]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFpInput((prev) => ({ ...prev, [name]: value }));
  };
  const novaFormaDePagamento = () => {
    setFpInput({
      descricao: "",
      tipo: "",
      ativo: true,
      tipoPagamento: "local",
      tipoOnline: "",
      asaasToken: "",
    });
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleClickOpenNew = () => {
    setOpen(true);
    novaFormaDePagamento();
  };

  const handleClickOpenEdit = (fp) => {
    setOpen(true);
    const { tipoPagamento, tipo } = fp;
    setFpInput({
      ...fp,
      tipo: tipoPagamento === "online" ? "" : tipo,
      tipoOnline: tipoPagamento === "online" ? tipo : "",
      tipoPagamento: tipoPagamento ? tipoPagamento : "local",
    });
  };

  const handleListFormaPagamento = () => {
    const service = new AuthService();
    service
      .get(`/formaPagamento/list?ativo=${actives}`)
      .then((res) => setFormaDePagamentos(res))
      .catch((err) => console.error(err));
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const openPicPayHelp = () => {
    setPicPayHelpDialog(true);
  };

  const openAsaasHelp = () => {
    setAsaasHelpDialog(true);
  };

  const handleSave = () => {
    const {
      descricao,
      tipoPagamento,
      tipo,
      tipoOnline,
      tipoChave,
      asaasToken,
      chavePix,
      nomeBeneficiario,
      picpayToken,
      cidadeBeneficiario,
    } = fpInput;

    if (!descricao) {
      enqueueSnackbar("Preencha o campo descrição", { variant: "error" });
      return;
    }
    const tipoSelecionado = tipoPagamento === "online" ? tipoOnline : tipo;

    if (!tipoSelecionado) {
      enqueueSnackbar("Preencha o campo tipo", { variant: "error" });
      return;
    }
    const isPix = tipoPagamento !== "online" && tipoSelecionado === "PIX";

    if (isPix && !tipoChave) {
      enqueueSnackbar("Preencha o campo tipo Chave", { variant: "error" });
      return;
    }

    if (isPix && !chavePix) {
      enqueueSnackbar("Preencha o campo Chave PIX", { variant: "error" });
      return;
    }

    if (isPix && !nomeBeneficiario) {
      enqueueSnackbar("Preencha o campo Nome Beneficiário", {
        variant: "error",
      });
      return;
    }

    if (isPix && !cidadeBeneficiario) {
      enqueueSnackbar("Preencha o campo Cidade Beneficiário", {
        variant: "error",
      });
      return;
    }

    if (tipoPagamento === "online" && !asaasToken) {
      enqueueSnackbar("Preencha o campo Chave Asaas", { variant: "error" });
      return;
    }
    if (tipoSelecionado === "PICPAY" && !picpayToken) {
      enqueueSnackbar("Preencha o campo Chave Picpay", { variant: "error" });
      return;
    }
    const service = new AuthService();
    service
      .post("/formaPagamento", { ...fpInput, tipo: tipoSelecionado })
      .then((resp) => {
        const updatedList = formaDePagamentos.filter(
          (fp) => fp.id !== fpInput.id
        );
        updatedList.push(resp);
        setFormaDePagamentos(updatedList);
        setOpen(false);
        enqueueSnackbar("Salvo com sucesso", { variant: "success" });
        handleListFormaPagamento();
      })
      .catch((err) => {
        enqueueSnackbar(
          "Erro ao cadastrar uma nova forma de pagamento." + err.message,
          { variant: "error" }
        );
      });
  };

  const tipos =
    fpInput.tipoPagamento === "local"
      ? TIPO_FORMAS_PAGAMENTO
      : TIPO_FORMAS_PAGAMENTO_ONLINE;

  return (
    <Template documentTitle="Formas de pagamento">
      <Box
        display="flex"
        flexDirection={isTablet ? "column" : "row"}
        justifyContent="space-between"
        alignItems="flex-end"
      >
        <Box sx={{ width: "100%" }}>
          <BarraTitulo
            title="Formas de pagamento"
            subTitle="Configure as formas de pagamento"
          />
        </Box>

        <Box
          sx={{
            width: isTablet ? "100%" : "auto",
            minWidth: "12rem",
            marginBottom: "0.75rem",
          }}
        >
          <Button
            color="primary"
            variant="contained"
            startIcon={<AddIcon />}
            size="medium"
            fullWidth
            onClick={handleClickOpenNew}
          >
            Forma pagamento
          </Button>
        </Box>
      </Box>

      <TableFormaDePagamento
        formaDePagamentos={formaDePagamentos}
        page={page}
        actives={actives}
        setActives={setActives}
        rowsPerPage={rowsPerPage}
        handleClickOpenNew={handleClickOpenNew}
        handleClickOpenEdit={handleClickOpenEdit}
        handleChangePage={handleChangePage}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
      />
      <DialogFormaDePagamento
        open={open}
        onClose={handleClose}
        handleChange={handleChange}
        fpInput={fpInput}
        tipos={tipos}
        openPicPayHelp={openPicPayHelp}
        openAsaasHelp={openAsaasHelp}
        handleSave={handleSave}
        handleClose={handleClose}
      />
      <HelperTokenPicpay
        onClose={() => setPicPayHelpDialog(false)}
        picPayHelpDialog={picPayHelpDialog}
      />
      <HelperTokenAsaas
        onClose={() => setAsaasHelpDialog(false)}
        asaasHelpDialog={asaasHelpDialog}
      />
    </Template>
  );
};

export default FormaPagamento;
